function PagesHeader({ text, heading, subheading }) {
  return (
    <div
      className={`bg-header-background bg-bottom-center bg-no-repeat bg-cover pt-44 md:pt-40 xl:pt-96 text-center w-full`}
    >
      <div className="xl:pt-10">
        <p className="text-2xl leading-snug font-medium text-primary-yellow">
          <span>{text}</span>
        </p>
        <h1
          className="text-4xl md:text-5xl lg:text-6xl font-normal text-white pb-8"
        >
          <span>
            {heading} <br />
            {subheading ?? undefined}
          </span>
        </h1>
      </div>
    </div>
  );
}

export default PagesHeader;
